<template>
  <div class="indicators"
      ref="indicators"
      :class="row.length === 0 ? 'one-indicators' : ''"
      :style="{height: drawer && isRowVirtual ? 'calc(100% - 90px)' : '', top: drawer && isRowVirtual ? '45px' : '', alignItems: height > 700 ? 'initial;' : '', display: isRowVirtual ? 'flex' : '', overflow: tableData.length > 0 && row.length > 0 && isRowVirtual == false ? 'auto' : 'hidden'}">
    <!-- 表格 -->
    <!-- 两个数据显示 -->
    <template v-if="tableData.length > 0 && row.length > 0 && isRowVirtual == false">
      <div class="total">
        <div class="name">共计</div>
        <div class="list-value">
          <template v-if="tableData[0].seriesType === 'name'">
            <div class="value">{{_getTotalSumm()}}</div>
          </template>
          <template v-else>
            <div v-for="(list, index) in summary" :key="'st' + index" class="value">{{ getTotalSumm(list) }}</div>
          </template>
        </div>
      </div>
      <div
        :class="
          selectIndex == index && selectPage == page ? 'select list' : 'list'
        "
        @click="relevanceFun(list.type, index, list.name, list.value)"
        v-for="(list, index) in tableData"
        :key="index"
      >
        <div class="name">{{ getName(list.name) }}</div>
        <div class="list-value">
          <template v-if="tableData[0].seriesType === 'name'">
            <div class="value">{{list.value}}</div>
          </template>
          <template v-else>
            <div class="value" v-for="(item, itemIndex) in summary" :key="'sum' + itemIndex">
            {{ list[item.title] }}
            </div>
          </template>
        </div>
      </div>
    </template>
    <!-- 一个数据显示 -->
    <template v-if="isRowVirtual == true">
      <div class="customize"
          :class="isEditor ? 'customize-hover' : 'no-editor'"
          :style="{
              width: width ? (width + 'px') : '100%',
              height: drawer ? 'calc(100% - 90px)' : height ? (height + 'px') : '100%',
              background: transparentBackground ? 'transparent' : 'url(' + $url + defaultStyleConfig.backImg + '?accesstoken=' + token + ')',
              borderColor: projectionTransparent ? 'transparent' : '#D8D8D8'
          }" @click="relevanceFunFun">
        <!-- 像素提示 -->
        <div class="pixel-w">{{width}}px</div>
        <div class="pixel-h">{{height}}px</div>
        <!-- 像素提示 end -->
        <div v-if="isEditor" class="customize-icon">
          <i class="el-icon-circle-plus-outline" @click="addShow = !addShow" />
          <i class="iconfont icon-shezhi21" @click="sysShow = !sysShow" />
          <div v-if="addShow" class="customize-button">
            <div :class="['button-list', defaultStyleConfig.title.show ? 'list-active' : '']"
                @click="changeConfig('title', 'show', !defaultStyleConfig.title.show)">标题</div>
            <div :class="['button-list', defaultStyleConfig.unit.show ? 'list-active' : '']"
                @click="changeConfig('unit', 'show', !defaultStyleConfig.unit.show)">单位</div>
            <div :class="['button-list', defaultStyleConfig.textArr.length > 0 ? 'list-active' : '']"
                @click="addText">文本</div>
            <div :class="['button-list', defaultStyleConfig.img.show ? 'list-active' : '']"
                @click="addImg">图片</div>
          </div>
        </div>
        <vue-draggable-resizable v-if="defaultStyleConfig.img.show"
                                :draggable="isEditor"
                                :resizable="isEditor"
                                :class="['customize-img', (imgShow || imgEditorShow) && isEditor && isFrontEnd ? 'actives' : '']"
                                :handles="['br']"
                                :parent="isEditor"
                                @activated="imgEditorShow = true"
                                @deactivated="imgEditorShow = false"
                                @dragstop="(x, y) => endDrag({x: x, y: y}, 'img')"
                                @resizestop="(x, y, w, h) => endDrag({x: x, y: y, w: w, h: h}, 'img')"
                                :w="defaultStyleConfig.img.w"
                                :h="defaultStyleConfig.img.h"
                                :y="defaultStyleConfig.img.y"
                                :x="defaultStyleConfig.img.x">
          <img v-if="typeof defaultStyleConfig.img.url == 'string'" :src="defaultStyleConfig.img.url.includes('userfiles') ? ($url + defaultStyleConfig.img.url + '?accesstoken=' + token) : (domain + defaultStyleConfig.img.url)" />
          <icon-module v-else :config="defaultStyleConfig.img.url" />
          <div v-if="isEditor" class="customize-editor">
            <i class="iconfont icon-bianji1"  @click="openIconPart(defaultStyleConfig.img.url)" />
            <i class="iconfont icon-a-shanchu2x" @click="changeConfig('img', 'show', false)" />
          </div>
        </vue-draggable-resizable>
        <vueDraggableResizable v-if="defaultStyleConfig.title.show && !nameShow"
                              :class="['customize-title', (titleShow || titleEditorShow) && isEditor && isFrontEnd ? 'actives' : '']"
                              :draggable="!titleShow && isEditor"
                              :resizable="isEditor"
                              :handles="['br']"
                              :w="defaultStyleConfig.title.w"
                              :h="defaultStyleConfig.title.h"
                              :x="defaultStyleConfig.title.x"
                              :y="defaultStyleConfig.title.y"
                              @activated="titleEditorShow = true"
                              @deactivated="titleEditorShow = false"
                              @dragstop="(x, y) => endDrag({x: x, y: y}, 'title')"
                              @resizestop="(x, y, w, h) => endDrag({x: x, y: y, w: w, h: h}, 'title')"
                              :parent="isEditor">
          <span ref="title"
                :contenteditable="isEditor"
                @blur="inputDiv($event, 'title')"
                :style="{
                  display: 'block',
                  color: defaultStyleConfig.title.color,
                  fontFamily: defaultStyleConfig.title.fontFamily,
                  fontSize: defaultStyleConfig.title.fontSize,
                  fontStyle: defaultStyleConfig.title.fontStyle,
                  textDecoration: defaultStyleConfig.title.textDecoration,
                  fontWeight: defaultStyleConfig.title.fontWeight,
                  textAlign: defaultStyleConfig.title.textAlign,
                }">
            {{ reName && reName !== "" ? reName : "未命名图表" }}
          </span>
          <div v-if="isEditor" class="customize-editor" contenteditable="false">
            <i class="iconfont icon-bianji1" @click="titleShow = true" />
            <i class="iconfont icon-a-shanchu2x" @click="changeConfig('title', 'show', false)" />
            <logoEdit v-if="titleShow"
                      :topContent="null"
                      :columnFont="defaultStyleConfig.title"
                      @close="titleShow = false"
                      @change-all-font="(val) => titleEditor(val, 'title')"
                      colorPosition="top" />
          </div>
        </vueDraggableResizable>
        <vueDraggableResizable :class="['customize-count', isEditor && (unitCountShow || unitEditorShow || unitShow) && isFrontEnd ? 'actives' : '', ('statistics-' + defaultStyleConfig.statistics.textAlign)]"
                              :parent="isEditor"
                              :draggable="isEditor && !unitCountShow && !unitShow"
                              :resizable="isEditor"
                              :handles="['br']"
                              @activated="unitEditorShow = true"
                              @deactivated="unitEditorShow = false"
                              @dragstop="(x, y) => endDrag({x: x, y: y}, 'unit')"
                              @resizestop="(x, y, w, h) => endDrag({x: x, y: y, w: w, h: h}, 'unit')"
                              :w="defaultStyleConfig.unit.w"
                              :h="defaultStyleConfig.unit.h"
                              :x="defaultStyleConfig.unit.x"
                              :y="defaultStyleConfig.unit.y">
          <div class="count-c">
            <span :style="{
              color: defaultStyleConfig.statistics.color,
              fontFamily: defaultStyleConfig.statistics.fontFamily,
              fontSize: defaultStyleConfig.statistics.fontSize,
              fontStyle: defaultStyleConfig.statistics.fontStyle,
              textDecoration: defaultStyleConfig.statistics.textDecoration,
              fontWeight: defaultStyleConfig.statistics.fontWeight,
              textAlign: defaultStyleConfig.statistics.textAlign,
            }">{{ getTotalValue }}</span>
            <div v-if="isEditor" class="customize-editor" contenteditable="false">
              <i class="iconfont icon-bianji1" @click="unitCountShow = true" />
              <logoEdit v-if="unitCountShow"
                        :topContent="null"
                        :columnFont="defaultStyleConfig.statistics"
                        @close="unitCountShow = false"
                        @change-all-font="(val) => titleEditor(val, 'statistics')"
                        colorPosition="top" />
            </div>
          </div>
          <div v-if="defaultStyleConfig.unit.show" class="count-t">
            <span :contenteditable="isEditor"
                  :style="{
                    color: defaultStyleConfig.unit.color,
                    fontFamily: defaultStyleConfig.unit.fontFamily,
                    fontSize: defaultStyleConfig.unit.fontSize,
                    fontStyle: defaultStyleConfig.unit.fontStyle,
                    textDecoration: defaultStyleConfig.unit.textDecoration,
                    fontWeight: defaultStyleConfig.unit.fontWeight,
                    textAlign: defaultStyleConfig.unit.textAlign,
                  }"
                  v-text="defaultStyleConfig.unit.unit"
                  @blur="inputDiv($event, 'unit')"></span>
            <div v-if="isEditor" class="customize-editor" contenteditable="false">
              <i class="iconfont icon-bianji1" @click="unitShow = true" />
              <i class="iconfont icon-a-shanchu2x" @click="changeConfig('unit', 'show', false)" />
              <logoEdit v-if="unitShow"
                        :topContent="null"
                        :columnFont="defaultStyleConfig.unit"
                        :isAlignIcon="false"
                        @close="unitShow = false"
                        @change-all-font="(val) => titleEditor(val, 'unit')"
                        colorPosition="top" />
            </div>
          </div>
        </vueDraggableResizable>
        <template v-if="defaultStyleConfig.textArr && defaultStyleConfig.textArr.length > 0">
          <vue-draggable-resizable v-for="(item, index) in defaultStyleConfig.textArr"
                                  :key="item.id"
                                  :class="['customize-text', (textObj1[item.id] || textObj[item.id]) && isEditor && isFrontEnd ? 'actives' : '']"
                                  :parent="false"
                                  :draggable="!textObj[item.id] && isEditor"
                                  :resizable="isEditor"
                                  @activated="focusText(item.id, true)"
                                  @deactivated="focusText(item.id, false)"
                                  :handles="['br']"
                                  :x="item.x"
                                  :y="item.y"
                                  :w="item.w"
                                  :h="item.h"
                                  @dragstop="(x, y) => endDrag({x: x, y: y}, 'textArr', index)"
                                  @resizestop="(x, y, w, h) => endDrag({x: x, y: y, w: w, h: h}, 'textArr', index)">
            <span :contenteditable="isEditor"
                  v-text="item.name"
                  @blur="inputDiv($event, 'textArr', index)"
                  :style="{
                      display: 'block',
                      color: item.color,
                      fontFamily: item.fontFamily,
                      fontSize: item.fontSize,
                      fontStyle: item.fontStyle,
                      textDecoration: item.textDecoration,
                      fontWeight: item.fontWeight,
                      textAlign: item.textAlign,
                  }"></span>
            <div v-if="isEditor" class="customize-editor" contenteditable="false">
              <i class="iconfont icon-bianji1" @click="editorText(item.id)" />
              <i class="iconfont icon-a-shanchu2x" @click="delText(item.id, index)" />
              <logoEdit v-if="textObj[item.id]"
                        :topContent="null"
                        :columnFont="item"
                        @close="textObj[item.id] = false"
                        @change-all-font="(val) => titleEditor(val, 'textArr', index)"
                        colorPosition="top" />
            </div>
          </vue-draggable-resizable>
        </template>
      </div>
    </template>
    <template v-else-if="tableData.length == 0">
      <div class="nodata">
        <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
        <div>暂无数据</div>
      </div>
    </template>
    <!-- <chooseIcon :url="defaultStyleConfig.img.url" :visible.sync="imgShow" @save="imgSaveFun" /> -->
    <icon-part ref="iconPart" @confirm="imgSaveFun"></icon-part>

    <sysGroup v-model:visible="sysShow"
              :config="defaultStyleConfig"
              :transparentBackground="transparentBackground"
              :projectionTransparent="projectionTransparent"
              @save="sysSave" />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'indicatorsCpn',
  props: {
    //- 表id
    id: {
      type: Number,
      default: 0
    },
    //- 表数据
    tableData: {
      type: Array,
      default: () => []
    },
    //- 分组字段数据
    row: {
      type: Array,
      default: () => []
    },
    //- 汇总字段数据
    summary: {
      type: Array,
      default: () => []
    },
    //- 表名
    reName: {
      type: String,
      default: ''
    },
    //- 字体大小
    fontSize: {
      type: Number,
      default: 0
    },
    //- 总数
    total: {
      type: Number || String,
      default: null
    },
    //- row当前状态是否为虚拟
    isRowVirtual: {
      type: Boolean,
      default: () => false
    },
    //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
    isFrontEnd: {
      type: Boolean,
      default: () => false
    },
    // 是否扩大显示
    drawer: {
      type: Boolean,
      default: () => false
    },
    selectIndex: {
      type: Number,
      default: () => null
    },
    page: {
      type: Number
    },
    selectPage: {
      type: Number,
      default: () => 1
    },
    // 颜色
    // color: {
    //   type: String
    // },
    // 图标
    // defaultImg: String,
    // 是否编辑
    isEditor: Boolean,
    // 联系人数据
    user: {
      type: Array,
      default: () => []
    },
    transparentBackground: {
      type: Boolean,
      default: false
    },
    projectionTransparent: {
      type: Boolean,
      default: false
    },
    nameShow: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    // 样式配置
    defaultStyleConfig: {
      type: Object,
      default: () => {
        return {
          backTransparent: false,
          projectionTransparent: false,
          backImg: '',
          w: 476,
          h: 268,
          icon: {
            type: 1,
            img: ''
          },
          title: {
            w: 200,
            h: 30,
            // x: 61,
            x: 171,
            y: 71,
            show: true,
            fontSize: '20px',
            fontFamily: '微软雅黑',
            fontWeight: 'normal', // 是否加粗
            fontStyle: 'normal', // 是否斜体
            textDecoration: 'none', // 是否下划线
            color: '#333333', // 选择的颜色
            textAlign: 'left' // 位置排版
          },
          // 统计数据
          statistics: {
            fontSize: '50px',
            fontFamily: '微软雅黑',
            fontWeight: 'normal', // 是否加粗
            fontStyle: 'normal', // 是否斜体
            textDecoration: 'none', // 是否下划线
            color: '#4e86ff', // 选择的颜色
            textAlign: 'left' // 位置排版
          },
          // 单位
          unit: {
            w: 240,
            h: 98,
            // x: 55,
            x: 171,
            y: 101,
            show: true,
            unit: '人',
            fontSize: '24px',
            fontFamily: '微软雅黑',
            fontWeight: 'normal', // 是否加粗
            fontStyle: 'normal', // 是否斜体
            textDecoration: 'none', // 是否下划线
            color: '#4e86ff', // 选择的颜色
            textAlign: 'left' // 位置排版
          },
          // 文本
          textArr: [],
          // 图片
          img: {
            w: 104,
            h: 104,
            x: 46,
            y: 70,
            show: true,
            url: 'facet-bg/10.svg'
          }
        }
      }
    }
  },
  components: {
    vueDraggableResizable: defineAsyncComponent(() => import('vue3-draggable-resizable')),
    logoEdit: defineAsyncComponent(() => import('@/components/common/logoEdit.vue')),
    sysGroup: defineAsyncComponent(() => import('./groupColumns')),
    IconPart: defineAsyncComponent(() => import('@/components/common/icon')),
    IconModule: defineAsyncComponent(() => import('@/components/common/icon/iconModule.vue'))
  },
  data () {
    return {
      // selectIndex: null
      domain: 'https://bigdata.topeti.com/PCRepository/middleground/home/icon/',
      token: '',
      unitEditorShow: false,
      titleEditorShow: false,
      imgEditorShow: false,
      titleShow: false,
      unitShow: false,
      unitCountShow: false,
      imgShow: false,
      sysShow: false,
      addShow: false,
      textObj: {},
      textObj1: {}
    }
  },
  computed: {
    getTotalValue () {
      let val = this.total
      if (val && typeof val === 'string') {
        val = val.replace(/\D/g, "")
      }
      return val || 0
    }
  },
  created () {
    try {
      const user = JSON.parse(localStorage.getItem('user'))
      this.token = user.accesstoken
    } catch (e) {
      console.log(e)
    }
  },
  watch: {
    defaultStyleConfig: {
      immediate: true,
      handler (val) {
        this.$emit('blur', val)
      }
    }
  },
  methods: {
    changeConfig (key1, key2, value) {
      const _defaultStyleConfig = cloneDeep(this.defaultStyleConfig)
      _defaultStyleConfig[key1][key2] = value
      this.$emit('update:defaultStyleConfig')
    },
    getName (val) {
      try {
        return typeof val === "string" ? val.split(/\1{1}/g).join('') : ''
      } catch (e) {
        return val && val !== 0 ? val : ''
      }
    },
    // 计算多个指标共计
    getTotalSumm (item) {
      let count = 0
      for (const i of this.tableData) {
        count += Number(i[item.title] || 0)
      }
      return count
    },
    // 计算指标共计
    _getTotalSumm () {
      let count = 0
      for (const i of this.tableData) {
        count += Number(i.value || 0)
      }
      return count
    },
    relevanceFunFun () {
      const obj = {}
      if (this.summary.length > 0) {
        obj[this.summary[0].revisabilityName] = this.total
      }
      const date = {
        id: this.id,
        value: obj,
        selectIndex: 0,
        selectPage: this.page
      }
      this.$emit("relevanceFun", date)
    },
    focusText (id, key) {
      this.$set(this.textObj1, id, key)
      // this.textObj1[id] = !this.textObj1[id]
    },
    endDrag (item, key, i) {
      const _defaultStyleConfig = cloneDeep(this.defaultStyleConfig)
      if (i || i === 0) {
        _defaultStyleConfig[key][i] = {
          ...this.defaultStyleConfig[key][i],
          ...item
        }
      } else {
        _defaultStyleConfig[key] = {
          ...this.defaultStyleConfig[key],
          ...item
        }
      }
      this.$emit('update:defaultStyleConfig', _defaultStyleConfig)
    },
    sysSave (val) {
      this.$emit('update:projectionTransparent', val.projectionTransparent)
      this.$emit('update:transparentBackground', val.backTransparent)
      delete val.projectionTransparent
      delete val.backTransparent
      this.$emit('update:defaultStyleConfig', val)
    },
    // 打开图标库
    openIconPart(config = undefined){
      // 打开图标库
      console.log(config);
      if(typeof config == 'string'){
        config = undefined
      }
      this.$refs.iconPart.open(config, false)
    },
    imgSaveFun (val) {
      const _defaultStyleConfig = cloneDeep(this.defaultStyleConfig)
      _defaultStyleConfig.img.url = val
      this.$emit('update:defaultStyleConfig', _defaultStyleConfig)
    },
    addImg () {
      const _defaultStyleConfig = cloneDeep(this.defaultStyleConfig)
      _defaultStyleConfig.img.show = !this.defaultStyleConfig.img.show
      this.$emit('update:defaultStyleConfig', _defaultStyleConfig)
    },
    editorText (id) {
      this.$set(this.textObj, id, true)
    },
    delText (id, i) {
      const _defaultStyleConfig = cloneDeep(this.defaultStyleConfig)
      _defaultStyleConfig.textArr.splice(i, 1)
      this.$emit('update:defaultStyleConfig', _defaultStyleConfig)
      delete this.textObj[id]
    },
    titleEditor (item, key, i) {
      if (key === 'textArr') {
        this.$set(this.defaultStyleConfig[key], i, item)
      } else {
        this.$set(this.defaultStyleConfig, key, item)
      }
    },
    inputDiv (e, key, i) {
      let text = ''
      try {
        text = e.target.innerText || e.target.innerText.replace(/[\s\r\n]/g, '').trim()
      } catch (e) {
        console.log(e)
      }
      const _defaultStyleConfig = cloneDeep(this.defaultStyleConfig)
      switch (key) {
        
        case 'unit':
          _defaultStyleConfig.unit.unit = text
          this.$emit('update:defaultStyleConfig', _defaultStyleConfig)
          break
        case 'textArr':
          _defaultStyleConfig.textArr[i].name = text
          this.$emit('update:defaultStyleConfig', _defaultStyleConfig)
          break
        case 'title':
          this.$emit('update:reName', text)
          break
      }
    },
    titleBlur (e) {
      const text = this.$refs[e].innerText
      this.$emit('update:reName', text)
    },
    addText () {
      const textArr = this.defaultStyleConfig.textArr
      console.log('当前', textArr)
      const obj = {
        w: 129,
        h: 27,
        x: 0,
        y: 0,
        name: '请输入文本',
        id: (textArr.length > 0 ? textArr[textArr.length - 1].id : 0) + 1,
        fontSize: '24px',
        fontFamily: '微软雅黑',
        fontWeight: 'normal', // 是否加粗
        fontStyle: 'normal', // 是否斜体
        textDecoration: 'none', // 是否下划线
        color: '#333333', // 选择的颜色
        textAlign: 'left' // 位置排版
      }
      const _defaultStyleConfig = cloneDeep(this.defaultStyleConfig)
      _defaultStyleConfig.textArr.push(obj)
      this.$emit('update:defaultStyleConfig', _defaultStyleConfig)
    },
    //- 双行指标图清除点击效果事件
    clearSelect () {
      // 没看到有调用的地方 先屏蔽
      // this.selectIndex = null;
    },
    //- 双行指标图点击事件，在客户端时候需要筛选查询该表单设置的对应关联表单
    relevanceFun (type, index, name, value) {
      console.log('指标点击', type, index, name, value)
      if (!name || name == undefined || this.isFrontEnd === true) {
        return;
      }
      // this.selectIndex = index;
      console.log("duib", type, index, name, value);
      if (type === 'status') {
        if (name === '已通过') {
          name = '1';
        } else if (name === '进行中' || name === '处理中') {
          name = '0';

        } else if (name === '未通过') {
          name = '2';
        } else if (name === '已撤回' || name === '已撤销') {
          name = '3';

        }
      }
      let rowName = this.row[0].name;
      let summaryName = this.summary[0].name;
      let array = {};
      const nameArr = name ? name.split(/\1{1}/g) : name;
      if (Array.isArray(nameArr)) {
        for (let i = 0; i < this.row.length; i++) {
          array[this.row[i].name] = nameArr[i]
        }
      } else {
        array[rowName] = nameArr;
      }
      // array[rowName] = name;
      array[summaryName] = value;
      let date = {
        id: this.id,
        value: array,
        selectIndex: index,
        selectPage: this.page
      }
      if (this.user[index]) date.user = this.user[index]
      console.log("点击值", date)
      this.$emit("relevanceFun", date)
    }
  }
}
</script>

<style scoped lang="scss">
  .statistics-left {
    justify-content: left;
  }
  .statistics-right {
    justify-content: right;
  }
  .statistics-center {
    justify-content: center;
  }
  .one-indicators {
    position: absolute !important;
    top: 0;
    left: 0;
  }
  .customize {
    width: 476px;
    height: 286px;
    background-color: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #D8D8D8;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    //top: 50%;
    //transform: translateY(-50%);
    background-repeat: no-repeat !important;
    background-size: 100% 100%;
    .pixel-h, .pixel-w  {
      position: absolute;
      font-size: 12px;
      z-index: 99999;
      padding: 2px;
      background: #4e86ff;
      color: #fff;
      border-radius: 4px;
      display: none;
    }
    .pixel-w {
      top: 0;
      left: calc(50% - 30px);
    }
    .pixel-h {
      right: 0;
      top: calc(50% - 20px);
    }
    .customize-icon {
      position: absolute;
      right: 0;
      top: 0;
      width: 65px;
      height: 33px;
      line-height: 33px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 6px;
      color: #FFFFFF;
      text-align: center;
      z-index: 10;
      i {
        font-size: 18px;
        cursor: pointer !important;
      }
      .el-icon-circle-plus-outline {
        font-size: 20px;
      }
      .customize-button {
        position: absolute;
        top: 33px;
        left: 0;
        background-color: #ffffff;
        color: #333333;
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        line-height: 30px;
        width: 65px;
        overflow: hidden;
        .button-list {
          margin-top: 1px;
          font-size: 14px;
          cursor: pointer !important;
          &:hover {
            background-color: rgba(78, 166, 255, 0.1);
          }
        }
        .list-active {
          background: rgba(78, 166, 255, 0.1);
          color: #4e86ff;
        }
      }
    }
    .customize-title {
      font-size: 24px;
      color: #333333;
      position: absolute;
      cursor: text !important;
      span {
        border: 1px dashed transparent;
        display: block;
        outline: none !important;
      }
    }
    .customize-count {
      display: flex;
      align-items: baseline;
      flex-wrap: wrap;
      color: #333333;
      border: 1px dashed transparent;
      position: absolute;
      .count-c {
        position: relative;
      }
      .count-t {
        position: relative;
        cursor: text !important;
        span {
          outline: 1px dashed transparent;
        }
      }
    }
    .customize-editor {
      display: none;
      width: 65px;
      line-height: 30px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 6px;
      position: absolute;
      right: -65px;
      top: 0;
      color: #ffffff;
      /*display: flex;*/
      align-items: center;
      justify-content: space-evenly;
      i {
        font-size: 16px;
        cursor: pointer !important;
      }
      :deep(.logo-edit) {
        position: absolute;
        left: 0;
        top: 30px;
      }
    }
    :deep(.handle-br) {
      width: 5px;
      height: 5px;
      position: absolute;
      bottom: -5px;
      right: -3px;
      border: 1px solid #4e86ff;
      border-radius: 50%;
      cursor: se-resize !important;
    }
    .customize-text {
      position: relative;
      border: 1px dashed transparent;
      cursor: text !important;
      span {
        outline: 1px dashed transparent;
      }
    }
    .customize-img {
      position: absolute;
      border: 1px dashed transparent;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .customize-hover {
    &:hover {
      border-color: #4e86ff !important;
      border-style: dashed;
    }
    &:hover .pixel-h, &:hover .pixel-w {
      display: block;
    }
  }
  .no-editor {
    border: none;
  }
  .actives {
    position: relative;
    z-index: 9 !important;
    border: 1px dashed #4e86ff !important;
  }
  .actives:focus {
    border-color: transparent;
    outline: none;
  }
  .actives .customize-editor {
    display: flex;
  }
:deep(.el-upload-list--text) {
  display: none;
}
.indicators {
  width: calc(100% - 2px);
  height: calc(100% - 1px);
  overflow: auto;
  position: relative;
  padding-right: 2px;
  padding-bottom: 1px;
  //display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  .nodata {
    color: #666666;
    display: inline-block;
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  &::-webkit-scrollbar {
    display: none;
  }
  .total,
  .list {
    width: calc(100% - 20px);
    height: 41px;
    line-height: 41px;
    font-size: 14px;
    color: #333333;
    border-bottom: 1px solid #e9e9e9;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .name {
      font-size: 12px;
      display: inline-block;
      float: left;
      max-width: 79%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .list-value {
      display: flex;
    }
    .value {
      font-size: 14px;
      border-radius: 4px;
      display: inline-block;
      float: right;
      padding: 2px 9px;
      text-align: center;
      line-height: 20px;
      vertical-align: top;
      margin-top: 7px;
      margin-left: 5px;
    }
  }
  .total {
    .name {
      color: rgba(32, 134, 218, 1);
    }
    .value {
      color: white;
      background: #4e86ff;
    }
  }
  .list {
    cursor: pointer;
    .value {
      border-radius: 4px;
      border: 1px solid rgba(151, 151, 151, 1);
    }
    &.select {
      /*color: #ffffff;*/
      background: #F1F8FF;
      /*.value {*/
      /*  border: 1px solid white;*/
      /*}*/
    }
  }
  .table {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    .one-table {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      padding-left: 30px;
      padding-right: 30px;
      .one-table-img {
        margin-right: 10px;
        text-align: right;
      }
      .one-table-center {
        text-align: left;
        .one-table-center-title {
          color: #666666;
        }
        .one-table-center-text {
          white-space:nowrap;
        }
      }
    }
  }
}
</style>
